var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSubtraction1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1921,
    height: 571.045,
    viewBox: "0 0 1921 571.045",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M1846.5,570.046H73.5a73.151,73.151,0,0,1-41.095-12.553,73.719,73.719,0,0,1-26.63-32.338A73.042,73.042,0,0,1,0,496.545V71.657l.022-.009c1.222-.48,12.518-4.872,32.564-11.186,12.384-3.9,25.637-7.762,39.39-11.476,17.194-4.643,35.226-9.07,53.595-13.156A1472.629,1472.629,0,0,1,271.8,11.2c29.849-3.529,60.412-6.26,90.839-8.117C396.1,1.036,430.241,0,464.1,0c36.809,0,74.225,1.224,111.209,3.638,39.833,2.6,80.221,6.649,120.043,12.035,20.939,2.832,42.155,6.093,63.058,9.691,21.575,3.714,43.422,7.893,64.935,12.421,22.176,4.667,44.617,9.835,66.7,15.361,22.733,5.688,45.732,11.916,68.356,18.511,163.112,47.545,329.7,71.654,495.131,71.656h.024c33.963,0,68.223-1.035,101.827-3.078,30.557-1.857,61.255-4.588,91.242-8.117a1490.046,1490.046,0,0,0,146.993-24.632c18.475-4.086,36.616-8.512,53.92-13.156,13.845-3.715,27.184-7.577,39.648-11.477,21.14-6.614,32.7-11.152,32.817-11.2V496.545a73.154,73.154,0,0,1-12.553,41.094,73.719,73.719,0,0,1-32.338,26.63A73.039,73.039,0,0,1,1846.5,570.046Z",
    transform: "translate(0.5 0.499)",
    fill: "#16c389",
    stroke: "#707070",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtraction1);
export default __webpack_public_path__ + "static/media/Subtraction 1.faec940027f2f76048c77d89ea8ec97d.svg";
export { ForwardRef as ReactComponent };